import { observer } from 'mobx-react-lite'
import { Box, FullPageWrapper, SpinnerLoader } from 'shared/ui'
import { useReviewsListContext } from 'pages/reviews/context'
import { EmptyStateReviews } from 'pages/reviews/pages/all/ui/EmptyStateReviews/EmptyStateReviews'
import { ReviewsListHeader } from 'pages/reviews/pages/all/ui/ReviewsListHeader/ReviewsListHeader'
import { ReviewsListTable } from 'pages/reviews/pages/all/ui/ReviewsListTable/ReviewsListTable'
import { TableSearch } from 'pages/reviews/pages/all/ui/TableSearch/TableSearch'

export const ReviewsListContent = observer(() => {
  const { isInitialLoading, isEmpty } = useReviewsListContext()

  if (isInitialLoading) {
    return <SpinnerLoader ariaLabel={'ReviewsListContent'} />
  }

  if (isEmpty) {
    return <EmptyStateReviews />
  }

  return (
    <FullPageWrapper>
      <ReviewsListHeader />
      <TableSearch />
      <Box
        display={'flex'}
        flexDirection={'column'}
        flex={1}
        paddingLeft={'16px'}
        paddingRight={'16px'}
      >
        <ReviewsListTable />
      </Box>
    </FullPageWrapper>
  )
})
